module.exports = __webpack_public_path__ + "img/mxrz.1984351f.png";